import {ApiClient} from '@hconnect/apiclient'
import {ShiftEventCommentDto} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'

export const EventCommentsQueryKey = 'events-comments'

type Params = {
  plantId: string
  eventId: string
  timezone: string
}

export const useComments = (
  {plantId, eventId, timezone}: Params,
  options?: Omit<UseQueryOptions<ShiftEventCommentDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const path = `${TasksApiPath.SHIFT_HANDOVER}/${plantId}/events/${eventId}/comments`

  return useQuery<ShiftEventCommentDto[], AxiosError>({
    queryKey: [EventCommentsQueryKey, eventId, plantId, timezone],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ShiftEventCommentDto[]>(path, {signal})
      return response.data
    },
    ...options
  })
}
